import Loadable from 'react-loadable';
import Loader from '../../components/UIComponents/Loader';

export const LoadableConcreteSection = Loadable({
  loader: () => import('./ConcreteSection'),
  loading: Loader
});
